/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drop_PhotoInputs */

const en_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop Photo`)
};

const es_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soltar foto`)
};

const fr_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déposer une photo`)
};

const de_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto ablegen`)
};

const ja_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写真をドロップ`)
};

const zh_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拖放照片`)
};

const ar_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إفلات صورة`)
};

const id_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lepaskan Foto`)
};

const it_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilascia foto`)
};

const ru_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перетащить фото`)
};

const pt_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soltar foto`)
};

const ko_drop_photo = /** @type {(inputs: Drop_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사진 놓기`)
};

/**
* | output |
* | --- |
* | "Drop Photo" |
*
* @param {Drop_PhotoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const drop_photo = /** @type {((inputs?: Drop_PhotoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drop_PhotoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_drop_photo(inputs)
	if (locale === "es") return es_drop_photo(inputs)
	if (locale === "fr") return fr_drop_photo(inputs)
	if (locale === "de") return de_drop_photo(inputs)
	if (locale === "ja") return ja_drop_photo(inputs)
	if (locale === "zh") return zh_drop_photo(inputs)
	if (locale === "ar") return ar_drop_photo(inputs)
	if (locale === "id") return id_drop_photo(inputs)
	if (locale === "it") return it_drop_photo(inputs)
	if (locale === "ru") return ru_drop_photo(inputs)
	if (locale === "pt") return pt_drop_photo(inputs)
	return ko_drop_photo(inputs)
});